/**
 * Stable role key identifiers — NOT wire values.
 *
 * Usage in route meta / components:
 *   import { ROLES } from '@/shared/constants/roles';
 *   meta: { requiredRole: ROLES.INSTRUCTOR }
 *
 * The guard / rbac helpers resolve 'INSTRUCTOR' → 'Instructor' via catalog.keyMap.
 */
export const ROLE_KEYS = Object.freeze({
  STUDENT:              'STUDENT',
  ADVISOR:              'ADVISOR',
  INSTRUCTOR:           'INSTRUCTOR',
  CURATOR:              'CURATOR',
  INSTITUTION_ADMIN:    'INSTITUTION_ADMIN',
  INSTRUCTOR_AND_ADMIN: 'INSTRUCTOR_AND_ADMIN',
  SUPER_ADMIN:          'SUPER_ADMIN',
});

/**
 * Alias so all existing `import { ROLES }` consumers keep working without changes.
 * Values are now stable key strings, not wire values.
 */
export const ROLES = ROLE_KEYS;
